import { Message, MessageType } from 'src/constants/types';
import { CampaignExternalType, CampaignListItem, CampaignType, ScheduledType } from '../types';
import { AwayMessageCampaignRequestData } from '../types/AwayMessageCampaignRequestData';

export function buildAwayMessageCampaignRequestData(messages: Message[], externalType: CampaignExternalType) {
  return {
    campaignType: 'away_message' as CampaignType,
    externalType: externalType,
    name: 'Away Message Campaign',
    scheduledMessages: messages.map(m => ({
      text: m.text,
      type: m.type,
      subject: m.subject,
      position: m.position,
      scheduledType: m.scheduledType,
      scheduledIntervals: m.scheduledIntervals ? m.scheduledIntervals : undefined,
    })),
  } as AwayMessageCampaignRequestData;
}

export function buildRecurringMessages(awayMessageCampaign: CampaignListItem) {
  const recurringMessages = awayMessageCampaign.scheduledMessages.filter(
    m => m.scheduledType === 'time_intervals',
  );

  if (recurringMessages.length) {
    return recurringMessages;
  }

  return [
    {
      text: '',
      type: 'sms' as MessageType,
      subject: '',
      links: [],
      position: 2,
      scheduledType: 'time_intervals' as ScheduledType,
      scheduledIntervals: [
        {
          startTime: '',
          endTime: '',
          daysOfWeek: [],
        },
      ],
    },
  ] as unknown as Message[];
}
